import React, { useEffect, useMemo } from 'react';
import { OverrideQuotedRatesContent } from 'components/override-quoted-rates';
import {
  OverrideQuotedRatesPageStore,
  OverrideQuotedRatesPageStoreContext,
  useOverrideQuotedRatesPageStore,
} from 'store/modules/override-rates/override-quoted-rates/pageStore';
import { useParams } from 'react-router-dom';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { bpHistory } from 'global/bpHistory';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { isInitialDataLoading, isActionLoading, getInitialData, returnBack, canOverrideRates, overrideRates } =
    useOverrideQuotedRatesPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <NoSidebarPageLayout
      contentWidth="standard"
      isActionLoading={isActionLoading}
      isInitialLoading={isInitialDataLoading}
      pageHeader={{
        title: 'Override Plan Rates',
        subtitle: 'Adjust your quoted rates by applying a discount or manually updating the values before submission',
        subtitleMaxWidth: '53rem',
        onBackButtonClick: returnBack,
      }}
      pageFooter={{
        onBack: returnBack,
        completeButtonText: 'Override Rates',
        disableCompleteButton: !canOverrideRates,
        onComplete: overrideRates,
      }}
    >
      <OverrideQuotedRatesContent />
    </NoSidebarPageLayout>
  );
});

const OverrideQuotedRatesPage: React.FC = () => {
  const { periodId, cartId, groupId, portfolioId, productLineId, bcIndex } = useParams<{
    groupId: string;
    periodId: string;
    cartId: string;
    portfolioId: string;
    productLineId: ProductLineId;
    bcIndex: string;
  }>();

  const pageStore = useMemo(
    () =>
      new OverrideQuotedRatesPageStore(
        {
          groupId,
          periodId,
          cartId,
          portfolioId: decodeURIComponent(portfolioId),
          productLineId,
          bcIndex: Number(bcIndex),
        },
        (): void => {
          bpHistory.push(`/proposal-override-rates/${periodId}?groupId=${groupId}&cartId=${cartId}`);
        },
      ),
    [],
  );

  return (
    <OverrideQuotedRatesPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </OverrideQuotedRatesPageStoreContext.Provider>
  );
};

export default OverrideQuotedRatesPage;
